export default function CustomMargin({children, className = ''}){
    return(
        <div className={`max-w-maxScreen m-auto ${className}`}>
            {children}
        </div>
    )
}
